import { PortalHelper } from "@/Common/Helpers/PortalHelper";
import { PrintHelper } from "@/Common/Helpers/PrintHelper";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";
import { ShareableGrowthChartModel } from "@/Patient/Models/GrowthCharts/ShareableGrowthChartModel";
import { PatientStore } from "@/Patient/Stores/PatientStore";

class PatientGrowthChartResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);

        this.RegisterOperation(ServerOperations.Server.Myle_Patient_BornPremature_Update, this.onBornPrematureUpdate);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_ExportCharts, this.printCharts);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_GetGrowthChartSharedItem, this.onLoadGrowthChartSharedItem);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_Portal_SyncSharedItem, this.onSyncGrowthChartSharedItem);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_Portal_RevokeSharedItem, this.onSyncGrowthChartSharedItem);
    }

    private onBornPrematureUpdate(response: ServerEvent, store: PatientStore): void {
        const data = response.Data;
        if (!data)
            return;

        let patientModel = store.PatientModels[data.PatientContactId];
        patientModel.IndividualResponse.IsBornPremature = data.IsBornPremature;
        patientModel.IndividualResponse.BornPrematureWeeks = data.BornPrematureWeeks;

        store.PatientModels[data.PatientContactId] = patientModel;
    }

    private printCharts(response: ServerEvent): void {
        const fileName = response.Data["FileName"];

        PrintHelper.ShowPrintPreviewFileName(fileName);
    }

    private onLoadGrowthChartSharedItem(response: ServerEvent, store: PatientStore): void {
        const data = response.Data;

        let model = store.GrowthChartUiModels[data.PatientContactId];
        if (model) {
            model = model
                .set("shareableGrowthChart", new ShareableGrowthChartModel(response.Data.ShareableGrowthChart))
                .set("portalLinkedItemModel", Immutable.fromJS(PortalHelper.getDefaultPortalLinkedItemModel()));

            store.GrowthChartUiModels[data.PatientContactId] = model;
        }
    }

    private onSyncGrowthChartSharedItem(response: ServerEvent, store: PatientStore): void {
        let model = store.GrowthChartUiModels[response.PatientId];
        let portalSyncModel = model.get("portalLinkedItemModel");

        if (response.hasErrors()) {
            portalSyncModel = portalSyncModel.set("ErrorMessage", response.Errors[0].Message);
            model = model.set("portalLinkedItemModel", portalSyncModel);

            store.GrowthChartUiModels[response.PatientId] = model;
            return;
        }

        const sharedItem = response.Data["SharedItem"];
        const sharedItemMessages = response.Data["Messages"];

        model.get("shareableGrowthChart").updateShareableModel(sharedItem, sharedItemMessages);

        portalSyncModel = portalSyncModel
            .set("SharedItem", sharedItem)
            .set("LinkedItemMessages", sharedItemMessages.toImmutable());

        model = model.set("isPortalPopupOpen", false);
        sessionStore.hideGlobalOverlay();

        portalSyncModel = portalSyncModel.set("IsSending", false);
        model = model.set("portalLinkedItemModel", portalSyncModel);

        store.GrowthChartUiModels[response.PatientId] = model;
    }
}

export { PatientGrowthChartResponseHandler };
